var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 496.2",
    style: {
      enableBackground: "new 0 0 496.2 496.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ABC96"
    },
    d: "M248.1,0C111.1,0,0,111.1,0,248.1s111.1,248.1,248.1,248.1s248.1-111.1,248.1-248.1S385.1,0,248.1,0z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1E"
    },
    d: "M418.5,382.8c-8.5-27.3-81.2-49.3-170.8-49.3s-161.5,22-170,49.3c-2.6,8.5-5.5,22.2-8.3,37.4 c45.1,46.9,108.5,76,178.7,76s133.6-29.2,178.7-76C424.1,405,421.2,391.2,418.5,382.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E7F2"
    },
    d: "M266.6,450.7v44.8c26.9-2,52.7-8.3,76.5-18.2v-26.6L266.6,450.7L266.6,450.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.6,
    y: 449.9,
    style: {
      fill: "#556877"
    },
    width: 76.5,
    height: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556877"
    },
    d: "M335.4,462.7h-31.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6h31.2c0.9,0,1.6-0.7,1.6-1.6 C337,463.4,336.3,462.7,335.4,462.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556877"
    },
    d: "M335.4,474.6h-31.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6h31.2c0.9,0,1.6-0.7,1.6-1.6 S336.3,474.6,335.4,474.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556877"
    },
    d: "M304.3,486.5c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6h0.6c4.1-1,8.2-2,12.2-3.2H304.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 461.1,
    style: {
      fill: "#556877"
    },
    width: 23.4,
    height: 29.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D8"
    },
    d: "M247.8,362.2l-41.5-26.7c0,0,22.4,108,41.9,108c19.6,0,41.7-108,41.7-108L247.8,362.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4D6D8"
    },
    points: "247.9,317 208.3,322.3 210.2,335.4 247.8,363.5 286,335.4 287.9,322.3  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A379"
    },
    d: "M287,282.1h-77.8c12.1,36.6,1,53.3,1,53.3l26.9,6.1h22l26.9-6.1C286,335.4,274.9,318.7,287,282.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3FAFF"
    },
    points: "287.9,322.3 282.1,358.8 305.8,337.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3FAFF"
    },
    points: "208.3,322.3 190.4,337.8 214.1,358.8  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3FAFF"
    },
    d: "M287.9,322.3l-39.8,19.2c0,0,34,17.3,34.2,17.1l23.5-20.8L287.9,322.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3FAFF"
    },
    d: "M208.3,322.3l-17.9,15.5l23.5,20.8c0.2,0.2,34.2-17.1,34.2-17.1L208.3,322.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#86B4D1"
    },
    points: "248.1,341.5 232.3,349.4 248.1,375 263.8,349.4  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86B4D1"
    },
    d: "M252.1,361.9H244l-11.3,53.3c5,16.6,10.3,28.2,15.4,28.2s10.4-11.5,15.3-27.9L252.1,361.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A4A54"
    },
    d: "M248.1,458.5v-15.1c0,0-34-84.7-34.2-84.8l-17.3-26.2l-12.5,6.4l8,55.3l16.3-3.7l-12,14.7 L248.1,458.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A4A54"
    },
    d: "M312.1,338.8l-12.5-6.4l-17.3,26.2c-0.2,0.2-34.2,84.8-34.2,84.8v15.1l51.7-53.4l-12-14.7l16.3,3.7 L312.1,338.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M248.1,61.6c-48.7,0-88.3,21.2-88.3,113.6c0,31.3,6.2,55.8,15.5,74.7c20.4,41.6,55.7,56.1,72.8,56.1 s52.4-14.5,72.8-56.1c9.3-18.9,15.5-43.4,15.5-74.7C336.4,82.8,296.8,61.6,248.1,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D89364"
    },
    d: "M260.2,259c-3.4-0.5-12.1,2.6-12.1,2.6s-8.7-3-12.2-2.6c-5.5,0.8-13.8,4.8-13.8,6.2 c0,2.3,11.6,8.6,26,8.6s26-6.3,26-8.6C274.1,265.3,265.8,259.8,260.2,259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE8757"
    },
    d: "M248.1,266.4c-15.4,0-26-1.1-26-1.1c0,2.3,11.6,11.2,26,11.2s26-8.9,26-11.2 C274.1,265.3,263.5,266.4,248.1,266.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M161.4,178c-8.4,1.4-14.9,5.1-10.1,32.9s10.7,29.1,19.1,27.7L161.4,178z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51250D"
    },
    d: "M318,93.2c-7.6-24.8-41.5-33.1-69.9-33.1c-48.7,0-88.3,31.8-88.3,118.2l20.3-3.4 c0-2.6,97-58.8,97-58.8c9.7,5.7,25,2,25,2c0-3.8,14.1,56.8,14.1,56.8l20.2,3.4C336.4,123.8,318,93.2,318,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51250D"
    },
    d: "M180.1,174.9l-14.6-34.1c-4.2,10.9-5.6,24.4-5.6,37.5c0,0,8.8-1.9,8.8,2.6l2.8,27.6l3.9-1.9 C175,183.6,180.1,174.9,180.1,174.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M334.9,178l-9,60.6c8.4,1.4,14.3,0.1,19.1-27.7C349.7,183.1,343.3,179.5,334.9,178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51250D"
    },
    d: "M330.8,140.8l-14.6,34.1c0,0,5.1,8.8,4.9,31.8l3.9,1.9l2.8-27.6c0-4.5,8.8-2.6,8.8-2.6 C336.5,165.1,335.1,151.7,330.8,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5AA17"
    },
    d: "M324.1,76.5c-13.5-20-50.5-37.3-75.8-37.3s-62.5,17.3-76,37.3c-12.6,18.6-15.9,71.4-11.2,71.4h174.2 C338.4,147.9,336.7,95.1,324.1,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC76C"
    },
    d: "M159.2,141.5l0.9,21c0,0,37.9,3.9,88,3.9s87.9-3.9,87.9-3.9l0.2-21H159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5AA17"
    },
    d: "M248.1,35.8c-17,0-30.7,3.4-30.7,10.5V69c0,7.1,13.7,86.9,30.7,86.9c16.9,0,30.7-79.8,30.7-86.9V46.3 C278.8,39.3,265,35.8,248.1,35.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C18D17"
    },
    d: "M217.5,46.3L217.5,46.3c-0.1-0.1-0.2-0.1-0.2,0l0,0c-0.8,1.9-1.1,3.8-1.4,5.7 c-0.2,0.9-0.2,1.9-0.3,2.8c-0.1,0.9-0.1,1.9-0.1,2.8s0,1.9,0.1,2.8s0.1,1.9,0.3,2.8c0.3,1.9,0.7,3.8,1.4,5.7l0,0l0.1,0.1 c0.1,0,0.1,0,0.1-0.1l0.1-11.3L217.5,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C18D17"
    },
    d: "M280.6,54.8c-0.1-0.9-0.1-1.9-0.3-2.8c-0.3-1.9-0.7-3.8-1.4-5.7l0,0l-0.1-0.1c-0.1,0-0.1,0-0.1,0.1 l-0.1,11.3l0.1,11.3c0,0,0,0.1,0.1,0.1s0.1,0,0.1-0.1l0,0c0.8-1.9,1.1-3.8,1.4-5.7c0.2-0.9,0.2-1.9,0.3-2.8 c0.1-0.9,0.1-1.9,0.1-2.8S280.7,55.8,280.6,54.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B21E"
    },
    d: "M266.3,42.8c0-7.1-8.1-12.8-18.2-12.8s-18.2,5.8-18.2,12.8l-12.1,96.7c0,7.1,20.3,12.8,30.3,12.8 s30.3-5.8,30.3-12.8L266.3,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5AA17"
    },
    d: "M332.5,129.2c-12.6-0.5-48.6,7.5-84.4,7.5c-35.3,0-70.4-8-82.6-7.5c-12.1,0-16.1,23.6-16.1,23.6 s42.5,4.3,98.8,4.3s98.6-4.3,98.6-4.3S343,129.2,332.5,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C18D17"
    },
    d: "M313.8,133.4c-7.4,0.5-14.7,0.9-22.1,1.2c-14.7,0.6-29.5,1.1-44.2,1c-14.7,0.1-29.5-0.4-44.2-1 c-7.4-0.3-14.7-0.7-22.1-1.2c-7.4-0.4-14.7-1-22.1-1.5c7.3,1,14.6,1.8,22,2.6c7.3,0.7,14.7,1.3,22.1,1.8c14.7,1,29.5,1.4,44.3,1.5 c14.8-0.1,29.5-0.5,44.3-1.5c7.4-0.5,14.7-1.1,22.1-1.8c7.3-0.8,14.7-1.5,22-2.6C328.5,132.4,321.2,133,313.8,133.4z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/no-avatar.dca1d1f5498195e2769f639913d736ea.svg";
export { ForwardRef as ReactComponent };